'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lingojsCore = require('@bookingcom/lingojs-core');

var NEW_DATE_LIST_FORMS = [
    'date_with_short_weekday_with_year',
    'date_with_weekday',
    'date_with_year',
    'date_without_year',
    'day_short_month_between',
    'day_short_month_year_between',
    'long_date_range_both_years',
    'month_with_year',
    'short_date',
    'short_date_with_weekday',
    'short_date_with_weekday_without_year',
    'short_date_without_year',
    'short_month_with_year'
];
var DATE_FORMAT_LIST = 'date_format';
var DATE_FORMAT_NEW_LIST = 'date_format_new';
[
    lingojsCore.SupportedLocales['en-gb'],
    lingojsCore.SupportedLocales['en-us'],
    lingojsCore.SupportedLocales.es
];
exports.TimeFormatItem = void 0;
(function (TimeFormatItem) {
    TimeFormatItem["time_12"] = "time_12";
    TimeFormatItem["time_24"] = "time_24";
    TimeFormatItem["time"] = "time";
})(exports.TimeFormatItem || (exports.TimeFormatItem = {}));

exports.DATE_FORMAT_LIST = DATE_FORMAT_LIST;
exports.DATE_FORMAT_NEW_LIST = DATE_FORMAT_NEW_LIST;
exports.NEW_DATE_LIST_FORMS = NEW_DATE_LIST_FORMS;
//# sourceMappingURL=constants.js.map
